<template>
  <div id="app">
    <Header/>
    <router-view />
    <Footer/>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    // eslint-disable-next-line
    Header: lzyheader.Header,
    // eslint-disable-next-line
    Footer: lzyfooter.Footer,
  },
  mounted() {
    //初始化头部和底部
    //this.initHeader()
  },
  methods: {
    // initHeader() {
    //   if (window.lzyheader) {
    //     window.lzyheader.init()
    //   }
    //   if (window.lzyfooter) {
    //     window.lzyfooter.init();
    //   }
    // }
  }
}
</script>

<style></style>
